<template>
  <div class="relative" :class="{'mb-4': frameStyle === 'standard'}">
    <div class="z-10">
      <template v-if="images.length > 1">
        <carousel :navigate-to="navigateTo" :per-page="1" :autoplay="autoplay" :adjustable-height="false" pagination-position="bottom-overlay">
          <slide v-for="(image,i) in filteredImages" :key="i">
            <cld-image :publicId="`${publicId(image)}`" :width="width" :height="height" crop="fill" responsive />
          </slide>
        </carousel>
      </template>
      <template v-else>
        <cld-image :publicId="`${publicId(images[0])}`" :width="width" :height="height" crop="fill" responsive />
      </template>

    </div>

    <div v-if="frameStyle === 'standard'" class="z-0 border border-white border-solid m-4 absolute frame top-0 left-0 pointer-events-none"></div>
    <div v-else class="z-0 border border-white border-solid m-2 absolute frame-small top-0 left-0 pointer-events-none"></div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import { uniq, last } from 'lodash'
export default {
  props: {
    images: {},
    navigateTo: {},
    height: {},
    frameStyle: {
      type: String,
      default: "standard"
    },
    width: {
      type: String,
      default: "500"
    },
    autoplay: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Slide,
    Carousel
  },
  methods: {
    publicId(image) {
      return last(image.split("/"))
    }
  },
  computed: {
    filteredImages() {
      return uniq(this.images)
    }
  }
}
</script>

<style>
.VueCarousel-pagination--bottom-overlay {
  bottom: 20px !important;
  z-index: 100;
  outline: none;
}
.VueCarousel-pagination--bottom-overlay:focus {
  outline: none;
}
</style>

<style scoped>
  .frame {
    width: calc(100% - 2rem);
    height: calc(100% - 2rem);
  }
  .frame-small {
    width: calc(100% - 1rem);
    height: calc(100% - 1rem);
  }
</style>